import { createAsyncThunk } from '@reduxjs/toolkit';
import { StudentLoanApi } from 'api/StudentLoanApi';

export interface GetStudentLoanApplicationData {
  applicationId: string;
}

export const createGetStudentLoanApplicationThunk = (api: StudentLoanApi) =>
  createAsyncThunk('studentLoan/getApplication', async (data: GetStudentLoanApplicationData, thunkApi) => {
    try {
      return await api.getApplication(data.applicationId);
    } catch (error: unknown) {
      thunkApi.rejectWithValue(error);

      throw error;
    }
  });
